import {gql} from '@apollo/client';

/**
 * @deprecated use the subscribable mutation instead
 */
export const AddChildRoomMoveQuery = gql`
    mutation AddChildRoomMoveQuery($childId: ChildId!, $groupId: GroupId!, $date: LocalDate!) {
        children {
            moveGroup(childId: $childId, groupId: $groupId, date: $date) {
                childId
                date
            }
        }
    }
`;
